import { Fragment } from "react";
import { CalendarCheck, CheckCheck, Clock, Send } from "lucide-react";
import { useLoopStep } from "./useLoopStep";
import "./how-mocks.css";

/** A workflow lights up node by node, a wait counts down, then the personalised message it sends appears and gets a reply. */
export default function FlowMock() {
  const [ref, step] = useLoopStep(14, 800);
  const nodes = [
    { Icon: CalendarCheck, title: "Visit completed", sub: "From Acuity", on: 1 },
    { Icon: Clock, title: "2 days later", sub: step >= 4 ? "Day 2" : step >= 3 ? "Day 1" : "Wait", on: 3 },
    { Icon: Send, title: "Send check‑in", sub: "On WhatsApp", on: 6 },
  ];
  return (
    <div className="hm fm" ref={ref}>
      <div className="fm-chain">
        {nodes.map(({ Icon, title, sub, on }, i) => (
          <Fragment key={title}>
            {i > 0 && <span className={`fm-conn${step >= on - 1 ? " is-on" : ""}`} aria-hidden><i /></span>}
            <div className={`fm-node${step >= on ? " is-on" : ""}`}>
              <span className="fm-node-icon"><Icon aria-hidden /></span>
              <b>{title}</b>
              <small>{sub}</small>
            </div>
          </Fragment>
        ))}
      </div>
      <div className="fm-chat">
        <div className="fm-chat-head"><span className="fm-avatar">PY</span><b>Priscilla Yeo</b><small>WhatsApp</small></div>
        <div className="fm-thread">
          {step < 6 && <p className="fm-idle">{step < 1 ? "Waiting for a trigger" : "Workflow running…"}</p>}
          {step === 7 && <div className="fm-bubble fm-bubble--out fm-typing"><i /><i /><i /></div>}
          {step >= 8 && (
            <div className="fm-bubble fm-bubble--out">
              Hi Priscilla, how did Friday go? Want to book your next visit? Same weekday evening works.
              <span className="fm-sent">Sent by Dibs <CheckCheck aria-hidden /></span>
            </div>
          )}
          {step >= 10 && <div className="fm-bubble fm-bubble--in">Yes please, Thursday evening?</div>}
        </div>
      </div>
    </div>
  );
}
